import { notify, confirm } from '../../utils/notify';
import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { vendorAPI } from '../../services/api';
import Topbar from "../../components/Topbar";

const money = n => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Number(n)||0);

function PaymentReports() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    vendorAPI.reports({type:'detailed'}).then(d=>setData(d)).catch(()=>{}).finally(()=>setLoading(false));
  },[]);

  return (
    <>
      <Header/>
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Vendor Payment" /><section className="container-fluid p-4 pt-3">
        <div className="page-hero"><div><h5 className="text-white lh-1">Vendor Payment Reports</h5><div className="sub">Vendor-wise, project-wise payment summary and analytics</div></div></div>

        {loading?<div className="text-center py-5"><span className="spinner-border text-primary"/></div>:(
          <>
            <div className="row g-2 mb-4">
              {[{l:'Total Requested',v:money(data?.summary?.totalRequested||0),bg:'#eff6ff',ic:'#3b82f6',icon:'bi-clipboard'},{l:'Total Paid',v:money(data?.summary?.totalPaid||0),bg:'#f0fdf4',ic:'#22c55e',icon:'bi-check-circle'},{l:'Total Pending',v:money(data?.summary?.totalPending||0),bg:'#fffbeb',ic:'#f59e0b',icon:'bi-hourglass'},{l:'Pending GRN',v:data?.summary?.pendingGRNCount||0,bg:'#fef2f2',ic:'#ef4444',icon:'bi-box-seam'}].map((s,i)=>(
                <div key={i} className="col-6 col-md-3"><div className="kpi-card d-flex align-items-center gap-2"><div className="kpi-icon" style={{background:s.bg}}><i className={`bi ${s.icon}`} style={{color:s.ic}}/></div><div><div style={{fontSize:'0.874rem',fontWeight:700,lineHeight:1.2}}>{s.v}</div><div style={{fontSize:'0.7rem',color:'#6b7280',marginTop:2}}>{s.l}</div></div></div></div>
              ))}
            </div>

            <div className="row g-2">
              {data?.byVendor&&Object.keys(data.byVendor).length>0&&(
                <div className="col-12 col-lg-6">
                  <div className="kpi-card">
                    <div style={{fontWeight:700,fontSize:'0.81rem',color:'#111827',marginBottom:8}}>Vendor-wise Payments</div>
                    {Object.entries(data.byVendor).sort((a,b)=>b[1]-a[1]).map(([vendor,amt])=>(
                      <div key={vendor} className="mb-2">
                        <div className="d-flex justify-content-between mb-1" style={{fontSize:'0.736rem'}}>
                          <span style={{color:'#374151',fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:'60%'}}>{vendor}</span>
                          <span style={{color:'#6b7280'}}>{money(amt)}</span>
                        </div>
                        <div style={{height:6,background:'#f3f4f6',borderRadius:3}}>
                          <div style={{height:'100%',background:'linear-gradient(90deg,#1a5276,#1e8449)',borderRadius:3,width:`${Math.min(100,(amt/(data.summary?.totalPaid||1))*100)}%`}}/>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {data?.statusDistribution&&(
                <div className="col-12 col-lg-6">
                  <div className="kpi-card">
                    <div style={{fontWeight:700,fontSize:'0.81rem',color:'#111827',marginBottom:8}}>Status Distribution</div>
                    {Object.entries(data.statusDistribution).map(([status,count])=>{
                      const colors = {PAID:'#22c55e',REJECTED:'#ef4444',PENDING_FINANCE:'#f59e0b',FINANCE_APPROVED:'#3b82f6',PAYOUT_INITIATED:'#7c3aed'};
                      return (
                        <div key={status} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'4px 0',borderBottom:'1px solid #f3f4f6',fontSize:'0.736rem'}}>
                          <div style={{display:'flex',alignItems:'center',gap:8}}>
                            <div style={{width:8,height:8,borderRadius:'50%',background:colors[status]||'#9ca3af'}}/>
                            <span style={{color:'#374151'}}>{status.replace(/_/g,' ')}</span>
                          </div>
                          <span style={{fontWeight:700,color:'#111827'}}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {data?.byProject&&Object.keys(data.byProject).length>0&&(
              <div className="kpi-card mt-3">
                <div style={{fontWeight:700,fontSize:'0.81rem',color:'#111827',marginBottom:8}}>Project-wise Summary</div>
                <div style={{overflowX:'auto'}}>
                  <table style={{width:'100%',fontSize:'0.718rem',borderCollapse:'collapse'}}>
                    <thead><tr style={{background:'#f9fafb'}}>{['Project Code','Requested','Paid','Pending'].map(h=><th key={h} style={{padding:'6px 8px',fontWeight:600,color:'#6b7280',textAlign:'left',border:'1px solid #f3f4f6'}}>{h}</th>)}</tr></thead>
                    <tbody>{Object.entries(data.byProject).map(([code,p],i)=>(
                      <tr key={code} style={{background:i%2===0?'#fff':'#fafafa'}}>
                        <td style={{padding:'6px 8px',border:'1px solid #f3f4f6',fontWeight:600,color:'#1d4ed8'}}>{code}</td>
                        <td style={{padding:'6px 8px',border:'1px solid #f3f4f6'}}>{money(p.requested||0)}</td>
                        <td style={{padding:'6px 8px',border:'1px solid #f3f4f6',color:'#16a34a',fontWeight:600}}>{money(p.paid||0)}</td>
                        <td style={{padding:'6px 8px',border:'1px solid #f3f4f6',color:'#f59e0b',fontWeight:600}}>{money((p.requested||0)-(p.paid||0))}</td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </section></main></div>
    </>
  );
}
export default PaymentReports;
